import { render, staticRenderFns } from "./TitleTabReadOnly.vue?vue&type=template&id=322708d6&"
import script from "./TitleTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./TitleTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports